import React, { useEffect, useState } from "react";
import { Alert, Col, Row, Spinner } from "react-bootstrap";
import axios from "axios";
import { Link } from "react-router-dom";
import SellerProductsTableComponent from "../../components/tables/Seller/SellerProductsTableComponent";
import PageLayout from "../../layouts/PageLayout";

const authHeaders = () => {
    const token = localStorage.getItem("authToken") || localStorage.getItem("AuthUser") || "";
    return { Authorization: `Bearer ${token}` };
};

export default function StoreSellerApprovedProductsPage() {
    const [products, setProducts] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        let isCurrentRequest = true;

        const fetchApprovedProducts = async () => {
            setLoading(true);
            setError("");

            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_URL}/store-seller/approved-products`,
                    {
                        headers: authHeaders(),
                    }
                );

                if (!isCurrentRequest) return;

                const responseData = response.data?.data;
                const productList = Array.isArray(responseData)
                    ? responseData
                    : Array.isArray(responseData?.data)
                        ? responseData.data
                        : [];

                setProducts(productList);
                setTotal(Number(response.data?.total ?? responseData?.total ?? productList.length));
            } catch (requestError) {
                if (!isCurrentRequest) return;
                console.error("Could not load approved store seller products:", requestError);
                setError(requestError.response?.data?.message || "Could not load approved products.");
            } finally {
                if (isCurrentRequest) setLoading(false);
            }
        };

        fetchApprovedProducts();
        return () => {
            isCurrentRequest = false;
        };
    }, []);

    const tableHeaders = [
        "Product Code",
        "Title",
        "Category",
        "Brand",
        "Condition",
        "Sell Price $",
        "Quantity",
        "Action",
    ];

    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className="mc-breadcrumb">
                            <h3 className="mc-breadcrumb-title">Approved by Admin ({total})</h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item">
                                    <Link to="/dashboard" className="mc-breadcrumb-link">Dashboard</Link>
                                </li>
                                <li className="mc-breadcrumb-item">Approved by Admin</li>
                            </ul>
                        </div>
                    </div>
                </Col>

                <Col xl={12}>
                    <div className="mc-card">
                        {error && <Alert variant="danger" className="mb-4">{error}</Alert>}
                        {loading ? (
                            <div className="text-center py-5">
                                <Spinner animation="border" variant="primary" />
                                <p className="mt-2 text-muted">Loading approved products...</p>
                            </div>
                        ) : (
                            <SellerProductsTableComponent
                                thead={tableHeaders}
                                tbody={products}
                                activeTab="approved"
                            />
                        )}
                    </div>
                </Col>
            </Row>
        </PageLayout>
    );
}
